import { useChannelsStore } from '@/store/useChannelsStore';
import { usePlayerStore } from '@/store/usePlayerStore';
import { ChannelCard } from '@/components/channel/ChannelCard';
import { PageHeader } from '@/components/common/PageHeader';
import { ChannelGridSkeleton } from '@/components/common/Skeleton';
import { Star } from 'lucide-react';

export function TopSportsPage() {
  const sportsChannels = useChannelsStore((s) => s.sportsChannels);
  const isLoading = useChannelsStore((s) => s.isLoadingInitial);
  const setCurrentChannel = usePlayerStore((s) => s.setCurrentChannel);
  const currentChannel = usePlayerStore((s) => s.currentChannel);

  if (isLoading) {
    return <ChannelGridSkeleton count={8} />;
  }

  const tagged = sportsChannels.filter((c) => c.broadcasterGroup === 'top-sports');

  return (
    <div className="flex flex-col gap-6 h-full">
      <PageHeader
        icon={<Star className="w-7 h-7 text-success" />}
        title="Top Sports Channels"
        subtitle={
          <>
            <span className="text-text">{tagged.length}</span> curated
          </>
        }
      />

      {tagged.length > 0 && (
        <section>
          <PageHeader
            size="section"
            icon={<Star className="w-5 h-5 text-success" />}
            title="Featured"
          />
          <div className="grid grid-cols-2 @md:grid-cols-3 @lg:grid-cols-4 @xl:grid-cols-6 gap-4 mt-3">
            {tagged.map((channel) => (
              <ChannelCard
                key={channel.id}
                channel={channel}
                onClick={setCurrentChannel}
                isActive={currentChannel?.id === channel.id}
              />
            ))}
          </div>
        </section>
      )}

      {tagged.length === 0 && (
        <div className="text-center py-12 text-text-muted">
          <Star className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p className="font-medium">No top sports channels available</p>
        </div>
      )}
    </div>
  );
}
